import {
  Grid,
  Typography,
  Slider,
  LinearProgress,
  Box,
  Tooltip
} from "@mui/material";
import React from "react";
import _ from "lodash";
import SkillLine from "./SkillLine";


export const SkillsList = (props) => {
  let similar_skills = props.job.similar_skills;
  let missing_skills = props.job.missing_skills;
  let occupationSkills = props.candidate.occupationSkills;
  let matchedSkills = [];
  let matchedSkillsObj = {};
  _.each(similar_skills, (skill) => {
    _.each(occupationSkills, (occskill) => {
      _.each(occskill.skills, (_skill) => {
        // will stop duplicates being added.
        if (skill === _skill.name && !matchedSkillsObj[_skill.name]){
          let skillLevel;
          let color;
          switch(_skill.level){
            case 0:
              skillLevel = "Unvalidated";
              color = "#A11842";
              break;
            case 1:
              skillLevel = "Beginner";
              color = "#00545E";
              break;
            case 2:
              skillLevel = "Proficient";
              color = "#5cd689";
              break;
            case 3:
              skillLevel = "Experienced";
              color = "#FDAE18";
              break;
            case 4:
              skillLevel = "Expert";
              color = "#624F85";
              break;
            default:
              skillLevel = "Unvalidated";
              color = "#A11842";
            break
          }
          _skill.skillLevel = skillLevel;
          _skill.color = color;
          matchedSkills.push(_skill);
          matchedSkillsObj[_skill.name] = true;
        }
      });
    });
  });

  matchedSkills = _.orderBy(matchedSkills, "level", "asc");

  /*eslint-disable*/
  const [value, setValue] = React.useState(props.job.score_bp);
  let jobDifference = "";
  let jobQualification = "unknown";
  /*eslint-enable*/
      const skills = () => {
        return <> 
        {similar_skills.length > 0 && (
        <>
        <Grid container sx={{ mt: 1.875, mb: 1.875 }}>
          <Grid item size={{xs:12}}>
            <Typography variant="body1"> Matching Skills </Typography>
          </Grid>
        </Grid>
        <div> 
          {matchedSkills.map((skill,index) => (
            <div style={{display:"block", width:"fit-content", marginBottom: 10}} key={`skill-list-${index}`} >
              <Tooltip title={skill.skillLevel} placement="top">
                <Box><SkillLine skill={skill}/></Box>
              </Tooltip>
            </div>
          ))}
        </div>
        </>
        )}
        {missing_skills.length > 0 && (
          <>
          <Grid container sx={{ mt: 1.875, mb: 1.875 }}>
            <Grid item size={{xs:12}}>
              <Typography variant="body1"> Missing Skills </Typography>
            </Grid>
          </Grid>
          <div> 
            {missing_skills.map((skill, index) => (
              <div style={{display:"block", width:"fit-content", marginBottom: 10}} key={`skill-list-missing-${index}`} >
                <SkillLine skill={{name: skill, level: 0}} />
              </div>
            ))}
          </div>
          </>
          )}
        </>
      }
    
    let category = 0;
    if (props.candidate && props.candidate.qualifications ){
        category = props.candidate.qualifications.category;
        jobQualification = props.candidate.qualifications.name;
        if (jobQualification === "" || !jobQualification) {
          jobQualification = "no qualifications"
        }
        if (!category || category === ""){
          category = 0;
        }
    }

    let jobscore = 1; let isQual = false;
    if (props.job && props.job.ONET_required_level_education){
      jobscore = props.job.ONET_required_level_education;
    }

    if (props.job && props.job.isQual){
      isQual = true;
    }

    if (parseInt(category) > parseInt(jobscore)) { 
      jobDifference = <><b>lower</b> than </>
    } else if (parseInt(category) === parseInt(jobscore)){
      jobDifference = <><b>similar</b> to </>;
    } else if (parseInt(category) < parseInt(jobscore)) {
      jobDifference = <><b>higher</b> than </>
    }
    /*eslint-disable*/
    const [qualificationValue, setQualificationValue] = React.useState([parseInt(category), parseInt(jobscore)]);
    /*eslint-enable*/
    return <div style={{ height: "100%", overflowY: "scroll", overflowX: "hidden", marginLeft: 5, paddingRight: 15 }}>
      <Grid container alignItems="center" sx={{ mt: 0, mb: 4.375 }}>
        <Grid item size={{xs:11}} sx={{ position: "relative" }}>
            <LinearProgress style={{width: value+"%",backgroundColor: "#53D28E"}} sx={{ position: "absolute", height: 20, borderRadius: '20px', left: 25, zIndex: 10 }}
            value={100}
            variant="determinate"
            color="#53D28E"
            aria-labelledby="discrete-slider-always"
            />
            <LinearProgress style={{width: "100%"}}  sx={{ position: "absolute", height: 20, borderRadius: '20px', left: 25 }}
            value={100}
            variant="determinate"
            color="primary"
            aria-labelledby="discrete-slider-always"
            />
        </Grid>
      </Grid>
      <Grid container justifyContent="center"  spacing={4}> 
        <Grid item> <Typography variant="caption"> Matching skills <div style={{ backgroundColor: "#53D28E", width: 15, height: 15, borderRadius: 20, marginLeft: 35, display: 'inline-block' }}></div></Typography></Grid>
        <Grid item> <Typography variant="caption"> Missing skills <div style={{ backgroundColor: "#E06923", width: 15, height: 15, borderRadius: 20, marginLeft: 30, display: 'inline-block' }}></div></Typography></Grid>
      </Grid>
      {skills()}
      {isQual === false && (
      <>
      <Grid item size={{xs:11}} sx={{ position: "relative" }} style={{marginTop: 75, marginBottom: 0, marginLeft: 25}}>
          <Slider
          sx={{ position: "absolute" }}
          value={parseInt(category)}
          min={0}
          max={11}
          valueLabelDisplay="on"
          valueLabelFormat={(value, index) => {
            if (qualificationValue[0] === qualificationValue[1]){
              return "\u2713";
            } else {
              return "YOU"
            }
          }}
        />
         <Slider
          sx={{ position: "absolute" }}
          value={parseInt(jobscore)}
          min={0}
          max={11}
          valueLabelDisplay="on"
          valueLabelFormat={(value, index) => {
            if (qualificationValue[0] === qualificationValue[1]){
              return "\u2713";
            }  else {
                if (isQual){
                  return "QUAL";
                } else {
                  return "JOB";
                }
            }
          }}
        />
      </Grid>
      <Grid container>
      <Grid sx={{ textAlign: "center", mt: 3.75, ml: 3.125 }} item size={{xs:11}}> <Typography  variant="caption"> On average the qualification required for this job is {jobDifference} <b>{jobQualification}</b> </Typography></Grid>
      </Grid>
      </>)}
      <Grid container justifyContent="center"  spacing={4}>
        <Grid style={{height: 100}} item size={{xs:12}}></Grid>
      </Grid>
    </div>
  };
